import { CURRENCIES } from '../constants/app'
import { mergeToNewObject } from './object.helpers'
import { trim } from './string.helpers'

const transWithArgs = (t, messageWithArgs) => {
  if (messageWithArgs) {
    const { message, args } = messageWithArgs
    return t(message, args)
  }
  return ''
}

const checkRulesAgainstValue = (rules, value) => {
  if (rules && rules.length > 0) {
    return rules.map((rule) => rule(value)).filter((msg) => msg !== '')
  }
  return []
}

const isValidPositiveDecimal = (value) => {
  const valid = /^\d+(\.\d{1,18})?$/
  return valid.test(value)
}

const positiveDecimalRule = (number) => {
  return number <= 0 || !isValidPositiveDecimal(number)
    ? formatValidator('home.invalid-number-format')
    : ''
}
const validPointValueRule = (number) => {
  return !isValidPointValue(number)
    ? formatValidator('home.invalid-number-format')
    : ''
}

const isValidPointValue = (value) => {
  return numberValidationRule().test(value)
}

const numberValidationRule = (numLimit = 5, decimalPoints = 10) => {
  return new RegExp(
    `^(\\d{0,${numLimit}}(\\.\\d{0,${decimalPoints}})?|\\.?\\d{0,${decimalPoints}})$`
  )
}

const formatValidator = (message, args) => {
  return { message, args }
}

const checkValidations = (fields) => {
  const newErrorMessages = Object.entries(fields).reduce((curr, next) => {
    const { value, rules } = next[1]
    const invalid = checkRulesAgainstValue(rules, value)?.[0]
    if (invalid) {
      return mergeToNewObject(curr, { [next[0]]: invalid })
    }
    return curr
  }, {})

  return newErrorMessages
}

const requiredRule = (value) => {
  return !isValidRequired(value) ? formatValidator('home.required-field') : ''
}

const isValidRequired = (value) => {
  return value && trim(String(value)).length
}

const maxValueRule = (max) => (value) => {
  return Number(value) > max
    ? formatValidator('home.wallet-balance', {
        symbol: CURRENCIES.DEFAULT,
        value: max
      })
    : ''
}

const isValidUUID = (number) => {
  const valid =
    /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/gi
  return valid.test(number)
}

const UUIDRule = (accountNumber) => {
  return !isValidUUID(accountNumber)
    ? formatValidator('staking.invalid-account-number')
    : ''
}

export {
  transWithArgs,
  checkRulesAgainstValue,
  positiveDecimalRule,
  validPointValueRule,
  checkValidations,
  requiredRule,
  maxValueRule,
  formatValidator,
  UUIDRule
}
